// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A34f2","clinicsSelect":"styles_clinicsSelect__1EOO5"};